export enum ENotificationType {
    ReminderSession = "reminder-session",
}
  